// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const sortData = (data, { asc, col }) => {
  let sortCol

  if (!col) {
    return data
  }

  // in the UI, we're displaying the string value for
  // analysis type and status but when we sort this column,
  // we actually want to sort by the id value and not the string value.
  switch (col) {
    case 'analysisType' :
      sortCol = 'analysisTypeId'
      break

    case 'analysisStatus' :
      sortCol = 'analysisStatusId'
      break

    default :
      sortCol = col
  }

  return data.concat().sort((a, b) => (
    asc
      ? a[sortCol] < b[sortCol] ? -1 : 1
      : a[sortCol] > b[sortCol] ? -1 : 1
  ))
}

export default sortData
